import img_quet_qr from './quet_qr.PNG';
import AIDAY_logo from './Logo-AIDay.png';
import Hoa_va_rac_logo from './Hoa_va_rac.jpg';
import React, { useReducer, useState, useEffect } from 'react';
import './App.css';
import CurrencyInput from 'react-currency-input-field';
import { Buffer } from 'buffer';
import useScript from './hooks/useScript';
import Cookies from 'universal-cookie';
import Select, { ClearIndicatorProps } from 'react-select';

var AES256 = require('aes-everywhere');
var MD5 = require('md5');

//Variables
const cookies = new Cookies();
var PAYONUSERNAME;
var PAYONPASSWORD;
var PAYONKEY;
var MERCHANTID;
var APPID;
const SERVERDOMAIN = 'ticket_booking_4_2_function';
const txt_form_QR1 = "1. Nếu đăng ký trên máy tính: Mở ứng dụng ngân hàng đã chọn -> Quét QR code -> Thanh toán.";
const txt_form_QR2 = "2. Nếu đăng ký trên điện thoại: Lưu ảnh QR code ở trên hoặc chụp screenshot màn hình -> Mở ứng dụng";
const txt_form_QR3 = "ngân hàng đã chọn -> Chọn thanh toán QR code -> Chọn ảnh QR code đã lưu -> Thanh toán.";
const txt_form_QR4 = "Sau khi thanh toán thành công, hệ thống sẽ gửi";
const txt_form_QR5 = "xác nhận kèm mã tham dự sự kiện qua tin nhắn Zalo hoặc đường Email (vui lòng kiểm tra thư mục Inbox hoặc Spam).";
const underQRText = "QR code có hiệu lực trong 24h. Nếu qua thời gian hiệu lực, vui lòng đăng ký lại từ đầu."
var accessToken = '';//current access token  
var voucher;
var creatorEvent;//current Event from Creator
var totalInputPrice;
var XungHo;
var payonQRCode;
var eventId;//current Event Id
var voucherList;
var no_of_ticket = 1;
var ticket_price = 0;
var collection_loai_ve = [];
var array_loai_ve = {};
var array_loai_ve_i = {};
const debugging = true;
var error_count = 0;
var error_log = "success!";
var Private;
var txt_QRBank_btn = "Lấy QR Code";
var eventName;
var Referer_options = [];
var danhsachHoiVien;
var event_csmo;
var Referer_Name;
var Referer_Phone;
var Referer_Email;
var English = false;
var Ticket_type;
//Variables cho bản Eng
var First_name = "Họ & đệm";
var Last_name = "Tên";
var Gender = "Giới tính";
var Male = "Nam";
var Female = "Nữ";
var txt_Ve = "Vé";
var txt_thanh_tien = "Thành tiền";
var txt_Company = "Tên công ty";
var txt_Position = "Vị trí";
var txt_Dang_ky = "Đăng ký";
var txt_guide_het_ve = "ĐÃ HẾT VÉ";
var txt_guide_0 = "HƯỚNG DẪN ĐĂNG KÝ VÉ";
var txt_guide_1 = "Bước 1: Điền thông tin cá nhân";
var txt_guide_2 = "Bước 2: Chọn ngày và số lượng vé mong muốn. Lưu ý số lượng có hạn. Mỗi lượt tối đa 2 vé";
var txt_guide_3 = "Bước 3: Nhận thông tin vé QR code qua email và Zalo (mã đăng ký). Vui lòng checkin tại cửa bằng mã QR đã được nhận.";


const formReducer = (state, event) => {
  if (event.type === 'UPDATE_FIELDS') {
    return {
      ...state,
      ...event.values
    };
  }
  return {
    ...state,
    [event.name]: event.value
  }
}

function App() {

  const [formData, setFormData] = useReducer(formReducer, {
    isHoiVienChinhThuc: false,
    isHoiVienDangKy: false,
    hoiVienId: '',
    hoiVienGioiThieuId: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [visible1, setVisible1] = useState(true);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [visible4, setVisible4] = useState(false);
  const [btn1Visible, setBtn1Visible] = useState(false);
  const [visible1_1, setVisible1_1] = useState(false);
  const [visible2_1, setVisible2_1] = useState(false);
  const [totalPrice, setPrice] = useState('');
  const [qrCode, setQRCode] = useState('');
  const [bank_url, setBankURL] = useState('');
  const [NoOfTicket, setNoOfTicket] = useState(1);
  const [TicketType, setTicketType] = useState();
  const [dataEnd, setdataEnd] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [enabled_column1, setEnabled_column1] = useState(true);
  const [visibleOption1, setvisibleOption1] = useState(false);
  const [visibleOption2, setvisibleOption2] = useState(false);
  const [QRBankenabled, setQRBankEnabled] = useState(true);
  const [Referer, setReferer] = useState('');
  const [txt_form_thongbao_0, setthongbao_0] = useState('Đăng ký thành công');
  const [txt_form_thongbao_1, setthongbao_1] = useState('');
  const [txt_form_thongbao_2, setthongbao_2] = useState('Email xác nhận & Tin nhắn ZNS sẽ được gửi trong vòng 5 phút');
  const [btn1disable, setbtn1disable] = useState(false);


  const MyComponent = props => {
    useScript('https://cdn.pagesense.io/js/zoho6828/b32610bbaf814180a3c9e695666cc87e.js');
    useScript('https://cdn.pagesense.io/js/zoho6828/b32610bbaf814180a3c9e695666cc87e.js');
    useScript('https://cdn.pagesense.io/js/zoho6828/3bd37b6764384bb196b7a41d8e707ce6.js');
  }

  //
  //Use
  //
  //set value onload
  useEffect(() => {
    console.log("Use Effect is executed only once!");

    //set icon ngân hàng
    setBankURL("https://www.ledr.com/colours/white.jpg");

    //Lấy ID của Event từ Creator
    const search = new URL(window.location).searchParams;
    eventId = search.get("eventId");
    Private = search.get("Private");
    English = search.get("English");
    if (English === "true") {
      First_name = "First name";
      Last_name = "Last name";
      Gender = "Gender";
      Male = "Male";
      Female = "Female";
      txt_Ve = "Ticket";
      txt_thanh_tien = "Amount";
      txt_Company = "Company";
      txt_Position = "Position";
      txt_Dang_ky = "Register";
      txt_guide_het_ve = "SOLD OUT";
      txt_guide_0 = "REGISTRATION GUIDES";
      txt_guide_1 = "Step 1: Fill in the box your information";
      txt_guide_2 = "Step 2: Select your desired date and the number of ticket(s). Please note that quantities are limited. Maximum 2 tickets per turn";
      txt_guide_3 = "Step 3: Receive your ticket via email and Zalo. Please check in at the door using the QR code received.";

    }

    if (debugging) {
      console.log("Event ID:")
      console.log(eventId);
    }

    Initialize()
      .then(tokenData => {
        accessToken = tokenData[0]["Token"]["AccessToken"];

        if (debugging) {
          console.log(`Access Token: ${accessToken}`);
        }
      })
      .then(async () => {
        if (eventId === "4246561000011317003") {
          voucherList = { "code": 3000, "data": [{ "Status": "Active", "Description": "", "Value_Type": "Minus", "Ma_hoi_vien": "false", "End_Date": "", "No_discount_by_quantity": "false", "Applied_ticket": "", "Voucher": "TEST5KGJIAGJISAIEO", "Effect_Value": "25000", "Applied_for_specific_ticket": "false", "Private": "false", "ID": "4246561000011597003", "one_ticket_per_use": "false", "Start_Date": "", "Use_time": "97", "Event_lookup": { "Event_name": "VIETNAM MOTOR SHOW 2024 - CÔNG NGHỆ MỞ TƯƠNG LAI XANH", "ID": "4246561000011317003", "zc_display_value": "VIETNAM MOTOR SHOW 2024 - CÔNG NGHỆ MỞ TƯƠNG LAI XANH" }, "Added_Time": "23/10/2024 21:52:36" }, { "Status": "Active", "Description": "", "Value_Type": "Percent", "Ma_hoi_vien": "false", "End_Date": "", "No_discount_by_quantity": "false", "Applied_ticket": "", "Voucher": "TEST100OANRTJERJHRJIV", "Effect_Value": "100", "Applied_for_specific_ticket": "false", "Private": "false", "ID": "4246561000011597007", "one_ticket_per_use": "false", "Start_Date": "", "Use_time": "97", "Event_lookup": { "Event_name": "VIETNAM MOTOR SHOW 2024 - CÔNG NGHỆ MỞ TƯƠNG LAI XANH", "ID": "4246561000011317003", "zc_display_value": "VIETNAM MOTOR SHOW 2024 - CÔNG NGHỆ MỞ TƯƠNG LAI XANH" }, "Added_Time": "23/10/2024 21:55:40" }] };
        }
        else {
          voucherList = await GetVouchers(eventId);
        }
      })
      .then(() => GetCurrentEvent(eventId))
      .then(creatorEventData => {
        creatorEvent = creatorEventData["data"];

        if (debugging) {
          console.log("Event: ");
          console.log(creatorEvent);
        }
        array_loai_ve = creatorEvent["Ticket_type"].split('\n');
        for (let i = 0; i < array_loai_ve.length; i++) {
          array_loai_ve_i = array_loai_ve[i].split(',');
          var this_loai_ve_disable = "false";
          // console.log(array_loai_ve_i[3]);
          // if(array_loai_ve_i[3]<1)
          // {
          //   this_loai_ve_disable="true";
          // }
          console.log(this_loai_ve_disable);
          let this_loai_ve = {
            "option_id": "loai_ve" + i,
            "loai_ve": array_loai_ve_i[0],
            "gia": array_loai_ve_i[1],
            "eng_loai_ve": array_loai_ve_i[2],
            "so_luong": array_loai_ve_i[3],
            "disable": this_loai_ve_disable
          }
          collection_loai_ve.push(this_loai_ve);
        }
        setFormData({
          name: 'Ticket_type',
          value: collection_loai_ve[0].loai_ve
        })
        Ticket_type = collection_loai_ve[0].loai_ve;
        setTicketType(collection_loai_ve[0].loai_ve);
        // txt_thanh_tien = creatorEvent["txt_Price"];

        //hiện câu hỏi
        if (eventId === "4246561000005522003") {
          setvisibleOption1(true);
          setvisibleOption2(true);
        }
        //đổi tên event
        eventName = creatorEvent["Event_name"];
        if (creatorEvent["Event_name"] === "Lunch & Learn: Hướng Chính Bắc Trong Hành Trình Trở Thành Nhà Lãnh Đạo Đích Thực") {
          eventName = "Lunch and Learn Hướng Chính Bắc Trong Hành Trình Trở Thành Nhà Lãnh Đạo Đích Thực";
        }
        if (eventId === "4246561000007894008") {
          eventName = "AI Day Ứng dụng Ai chìa khóa kinh doanh Bứt Phá";
        }
        event_csmo = creatorEvent["Event_CSMO"];
      })
      // .then(() => GetPayon(creatorEvent["Payon"]["ID"])
      .then(payonData => {
        // console.log(payonData["data"]);
        // PAYONUSERNAME = payonData["data"]["Payon_Username"];
        // PAYONPASSWORD = payonData["data"]["Payon_Password"];
        // PAYONKEY = payonData["data"]["Payon_Key"];
        // MERCHANTID = payonData["data"]["Merchant_Id"];
        // APPID = payonData["data"]["App_Id"];

        //mặc định csmo
        PAYONUSERNAME = "PayOnSDK";
        PAYONPASSWORD = "1393748dcdfa24c734b5b404131f5c65";
        PAYONKEY = "qRSKbspVLRARmkndJq4LYX";
        MERCHANTID = "1621907";
        APPID = "1621907PCJgc5pQ";
        if (eventId === "4246561000011317003") {
          PAYONUSERNAME = "PayOnSDK";
          PAYONPASSWORD = "1393748dcdfa24c734b5b404131f5c65";
          PAYONKEY = "w8nbUBEaqWNyi93xrF8ARF";
          MERCHANTID = "1663343";
          APPID = "1663343AELyS5DN";
        }
        if (eventId === "4246561000010098003" || eventId === "4246561000012392003") {
          PAYONUSERNAME = "PayOnSDK";
          PAYONPASSWORD = "1393748dcdfa24c734b5b404131f5c65";
          PAYONKEY = "7fnSesvgAhT3QTfgQWTCda";
          MERCHANTID = "1652934";
          APPID = "1652934UZzJPBj7";
        }
        //
        totalInputPrice = Number(creatorEvent["Ticket_Price"]) * NoOfTicket;
        //giảm n% cho early bird
        if (creatorEvent["Early_bird"] === "true") {
          totalInputPrice = totalInputPrice * (100 - creatorEvent["Discount_Value"]) / 100;
        }
        setPrice(totalInputPrice);

        setFormData({
          name: 'Price',
          value: totalInputPrice
        })
        setFormData({
          name: 'Number_of_Tickets',
          value: 1
        })
        setFormData({
          name: 'Merchant_Request_Id',
          //Data Type: Number
          value: Math.floor(Date.now() / 1000)
        })
        setFormData({
          name: 'Event_name',
          value: eventName
        })
        setFormData({
          name: 'Ticket_price',
          value: Number(creatorEvent["Ticket_Price"])
        })
        setFormData({
          name: 'Event_code',
          value: eventId
        })
        setFormData({
          name: 'Company',
          value: ''
        })
        setFormData({
          name: 'Address',
          value: ''
        })
        setFormData({
          name: 'Tax_code',
          value: ''
        })
        setFormData({
          name: 'Position',
          value: ''
        })
        setFormData({
          name: 'ZNS_ID',
          value: creatorEvent["ZNS_ID"]
        })
        setFormData({
          name: 'Zeptomail_ID',
          value: creatorEvent["Zeptomail_ID"]
        })
        setFormData({
          name: 'LayHoaDon',
          value: false
        })
        setTimeout(() => {
          setEnabled(true);//enable nút +/-, loại vé
          // if(eventId=="4246561000014272015")
          // {
          var disabled_option = 0;
          for (let i = 0; i < collection_loai_ve.length; i++) {
            if (collection_loai_ve[i].disable === "true") {
              document.getElementById(collection_loai_ve[i].option_id).disabled = true;
              document.getElementById(collection_loai_ve[i].option_id).checked = false;
              disabled_option++;
            }
            else {
              document.getElementById(collection_loai_ve[i].option_id).disabled = false;
              document.getElementById(collection_loai_ve[i].option_id).checked = true;
              setTicketType(collection_loai_ve[i].loai_ve);
              ticket_price = collection_loai_ve[i].gia;
              setFormData({
                name: 'Ticket_price',
                value: ticket_price
              })
              setFormData({
                name: 'Ticket_type',
                value: collection_loai_ve[i].loai_ve
              })
              Ticket_type = collection_loai_ve[i].loai_ve;
            }
          }
          if (disabled_option === collection_loai_ve.length) {
            setbtn1disable(true);
            txt_Dang_ky = "Đã hết vé";
            if (English === "true") {
              txt_Dang_ky = "Sold out";
            }
          }
          // } 
        }, 3000);

        //Load hoi_vien_csmo
        if (event_csmo === "true") {
          getHoiVienCSMO()
            .then(hoivienData => {
              danhsachHoiVien = hoivienData;
              for (let i = 0; i < danhsachHoiVien.length; i++) {
                let this_option = {
                  "value": danhsachHoiVien[i].Hoi_vien_CSMO.Ten_va_cong_ty,
                  "label": danhsachHoiVien[i].Hoi_vien_CSMO.Ten_va_cong_ty
                }
                Referer_options.push(this_option);
              }
            })
        }

      })
      .catch(err => {
        console.error(err);
      })

  }, [""]);

  //
  //Fields Handler
  //
  const handleChange = async (event) => {
    const isCheckBox = event.target.type === 'checkbox';

    if (event.target.name === 'Mobile') {
      //doing
      let First_nameField = document.getElementById("First_name");
      let Last_nameField = document.getElementById("Last_name");
      let EmailField = document.getElementById("Email");
      let CompanyField = document.getElementById("Company");
      let PositionField = document.getElementById("Position");
      let namRadioField = document.getElementById("nam");
      let nuRadioField = document.getElementById("nu");
      let increBtn = document.getElementById("increBtn");
      let decreBtn = document.getElementById("decreBtn");
      let spanFirstname = document.getElementById("spanFirstName");
      let spanLastName = document.getElementById("spanLastName");
      let spanEmail = document.getElementById("spanEmail");
      let hoivienFormData = {};
      let reset = true;

      if (danhsachHoiVien != null) {
        //Nếu mobile trống thì k search
        if (event.target.value) {
          var find_phone = danhsachHoiVien.find(e => e.Hoi_vien_CSMO.Sdt === event.target.value);

          //Nếu tìm thấy
          if (find_phone != null) {
            reset = false;
            console.log(find_phone);
            var Hoivien_Ten_va_cong_ty = find_phone.Hoi_vien_CSMO.Ten_va_cong_ty.replace(" - ", ";").split(';');
            var Hoivien_HoTen = Hoivien_Ten_va_cong_ty[0].split(' ');
            var Hoivien_Ten = Hoivien_HoTen[Hoivien_HoTen.length - 1];
            var Hoivien_Email = find_phone.Hoi_vien_CSMO.Email;
            var Hoivien_Company = Hoivien_Ten_va_cong_ty[1];
            var Hoivien_Gender = find_phone.Hoi_vien_CSMO.Male ? 'nam' : 'nu';
            console.log(Hoivien_Ten_va_cong_ty);
            // Gán các giá trị từ CSMO Member
            First_nameField.value = Hoivien_Ten_va_cong_ty[0].replace(" " + Hoivien_Ten, "");
            Last_nameField.value = Hoivien_Ten;
            EmailField.value = Hoivien_Email;
            CompanyField.value = Hoivien_Company;
            PositionField.value = 'Lãnh đạo (C-level)';
            document.getElementById(Hoivien_Gender).checked = true;
            setNoOfTicket(1);
            hoivienFormData.isHoiVienDangKy = false;
            hoivienFormData.isHoiVienChinhThuc = true;
            hoivienFormData.hoiVienId = find_phone.Hoi_vien_CSMO.Creator_ID;
            // Disable các trường còn lại
            First_nameField.disabled = true;
            Last_nameField.disabled = true;
            EmailField.disabled = true;
            CompanyField.disabled = true;
            PositionField.disabled = true;
            namRadioField.disabled = true;
            nuRadioField.disabled = true;
            increBtn.disabled = true;
            decreBtn.disabled = true;
            // Điều chỉnh style
            First_nameField.style.color = "#666666";
            First_nameField.style.backgroundColor = "#E8ECEF";
            Last_nameField.style.color = "#666666";
            Last_nameField.style.backgroundColor = "#E8ECEF";
            EmailField.style.color = "#666666";
            EmailField.style.backgroundColor = "#E8ECEF";
            CompanyField.style.color = "#666666";
            CompanyField.style.backgroundColor = "#E8ECEF";
            PositionField.style.color = "#666666";
            PositionField.style.backgroundColor = "#E8ECEF";
            increBtn.style.color = "#666666";
            decreBtn.style.color = "#666666";
            spanFirstname.style.transform = "translateX(-5px) translateY(-26px)";
            spanLastName.style.transform = "translateX(-5px) translateY(-26px)";
            spanEmail.style.transform = "translateX(-5px) translateY(-26px)";
          }
        }
      }
      if (reset && First_nameField.disabled === true) {
        // Reset giá trị
        First_nameField.value = '';
        Last_nameField.value = '';
        EmailField.value = '';
        CompanyField.value = '';
        PositionField.value = '';
        namRadioField.checked = false;
        nuRadioField.checked = false;
        setNoOfTicket(1);
        hoivienFormData.isHoiVienDangKy = false;
        hoivienFormData.isHoiVienChinhThuc = false;
        hoivienFormData.hoiVienId = '';
        hoivienFormData.isHoiVienChinhThuc = false;
        hoivienFormData.hoiVienId = '';
        // Gỡ Disabled
        First_nameField.disabled = false;
        Last_nameField.disabled = false;
        EmailField.disabled = false;
        CompanyField.disabled = false;
        PositionField.disabled = false;
        namRadioField.disabled = false;
        nuRadioField.disabled = false;
        increBtn.disabled = false;
        decreBtn.disabled = false;
        // Style
        First_nameField.style.color = "";
        First_nameField.style.backgroundColor = "";
        Last_nameField.style.color = "";
        Last_nameField.style.backgroundColor = "";
        EmailField.style.color = "";
        EmailField.style.backgroundColor = "";
        CompanyField.style.color = "";
        CompanyField.style.backgroundColor = "";
        PositionField.style.color = "";
        PositionField.style.backgroundColor = "";
        increBtn.style.color = "";
        decreBtn.style.color = "";
        spanFirstname.style.transform = "";
        spanLastName.style.transform = "";
        spanEmail.style.transform = "";
      }
      // Set form data
      setFormData({
        name: "First_name",
        value: First_nameField.value
      })
      setFormData({
        name: "Last_name",
        value: Last_nameField.value
      })
      setFormData({
        name: "Gender",
        value: namRadioField.checked === true ? 'Nam' : 'Nữ'
      })
      setFormData({
        name: "Email",
        value: EmailField.value
      })
      setFormData({
        name: "Company",
        value: CompanyField.value
      })
      setFormData({
        name: "Position",
        value: PositionField.value
      })
      setFormData({
        type: "UPDATE_FIELDS",
        values: hoivienFormData
      })
    }

    if (event.target.name === 'LayHoaDon') {
      if (event.target.checked) {
        setVisible1_1(true);
        setdataEnd(!dataEnd);
      }
      else {
        setVisible1_1(false);
        setdataEnd(!dataEnd);
      }
    }

    if (event.target.name === 'bank') {
      if (event.target.value === "") {
        setBankURL("https://www.ledr.com/colours/white.jpg");
      }
      else {
        setBankURL("https://payment.vimo.vn/images/bank/favicon/" + event.target.value + ".png");
        if (!visible2_1) {
          setVisible2_1(!visible2_1);
        }
      }
    }

    setFormData({
      name: event.target.name,
      value: isCheckBox ? event.target.checked : event.target.value
    })
  }

  const voucherChange2 = async (event) => {
    //Lấy voucher từ tên voucher được truyền vào và gán vào object
    if (event.target.name === 'Voucher') {
      voucher = voucherList["data"].find(x => x.Voucher === event.target.value.toUpperCase());
      var allow_voucher = 1;
      if (voucher !== undefined) {
        //Nếu có voucher
        //voucher = data.data[0];

        if (debugging) {
          console.log(voucher);
        }


        //Nếu voucher chỉ áp dụng cho 1 số vé
        if (voucher["Applied_for_specific_ticket"] === "true") {
          setEnabled_column1(false);
          setTicketType(voucher["Applied_ticket"]);
          setFormData({
            name: 'Ticket_type',
            value: voucher["Applied_ticket"]
          })
          Ticket_type = voucher["Applied_ticket"];
          ticket_price = collection_loai_ve.find(e => e.loai_ve === voucher["Applied_ticket"]).gia;
          setFormData({
            name: 'Ticket_price',
            value: ticket_price
          })
        }


        //voucher dùng cho 1 vé
        if (voucher["one_ticket_per_use"] === "true") {
          setEnabled(false);
          no_of_ticket = 1;
          setNoOfTicket(no_of_ticket);
          setFormData({
            name: 'Number_of_Tickets',
            value: no_of_ticket
          })
        }

        setFormData({
          name: event.target.name,
          value: event.target.value
        })

      }
      else {
        //Nếu k có voucher
        voucher = undefined;

        setFormData({
          name: event.target.name,
          value: ''
        })
      }
      // Tính số tiền phải trả sau khi đã áp dụng voucher
      CalculateDiscount(voucher);

    }
    if (event.target.name === 'Number_of_Tickets') {
      //Tính số tiền phải trả sau khi đã áp dụng voucher
      CalculateDiscount(voucher);

      setFormData({
        name: event.target.name,
        value: event.target.value
      })
    }

    //voucher sinh viên
    // if(event.target.value.toUpperCase()==='SV200')
    // {
    //   collection_loai_ve=[{loai_ve: 'Tham dự hội thảo', gia: '1000000'}];
    //   setTicketType('Tham dự hội thảo');
    // ticket_price=collection_loai_ve.find(e=>e.loai_ve==='Tham dự hội thảo').gia;
    //   setFormData({
    //     name: 'Ticket_price',
    //     value: ticket_price
    //   })
    //   setFormData({
    //     name: 'Ticket_type',
    //     value: event.target.value
    //   })
    //   CalculateDiscount(voucher);
    // }
  }

  const handleClick1 = async (e) => {
    e.preventDefault();

    //cookie
    // cookies.set('Name',  formData["First_name"]+" "+formData["Last_name"], { path: '/' });
    // cookies.set('Phone', formData["Mobile"], { path: '/' });
    // cookies.set('Email', formData["Email"], { path: '/' });
    // localStorage.setItem("Name", formData["First_name"]+" "+formData["Last_name"]);
    // localStorage.setItem("Phone",  formData["Mobile"]);
    // localStorage.setItem("Email",  formData["Email"]);

    var Validate = 0;//0 => pass
    var alert_msg = "Vui lòng nhập ";

    if (debugging) {
      console.log("Form Data:");
      console.log(formData);
    }

    if (formData["LayHoaDon"] === true) {
      if (formData["Company"] === '') {
        Validate = 1;
        alert_msg = alert_msg + "Tên công ty";
      }
      if (formData["Address"] === '') {
        if (Validate > 0) {
          alert_msg = alert_msg + ", ";
        }
        Validate = 1;
        alert_msg = alert_msg + "Địa chỉ";
      }
      if (formData["Tax_code"] === '') {
        if (Validate > 0) {
          alert_msg = alert_msg + ", ";
        }
        Validate = 1;
        alert_msg = alert_msg + "Mã số thuế";
      }
    }

    if (Validate === 1) {
      alert(alert_msg);
    }
    else {
      if (formData["LayHoaDon"] === true) {
        InsertNewTicketBooking().then(data => {
          if (debugging === true) {
            console.log('Insert response');
            console.log(data);
          }
        });

        setVisible1(current => !current);
        setVisible4(current => !current);
      }
      else {
        setVisible1(current => !current);
        if (totalInputPrice === 0) {
          setVisible4(current => !current);
          if (formData["Gender"] === "Nam") {
            XungHo = "anh";
            if (English === "true") {
              XungHo = "Mr.";
            }
          }
          else {
            XungHo = "chị"
            if (English === "true") {
              XungHo = "Ms.";
            }
          }
          if (English === "true") {
            setthongbao_0("Registration completed successfully!")
            setthongbao_1("Thank you for registering for the event Hoa & Rác (Rejoice and Refuse) in Hanoi");
            setthongbao_2("The confirmation Email & ZNS message will be sent within 5 minutes.")
          }
          else {
            setthongbao_1("Cảm ơn " + XungHo + " " + formData["Last_name"] + " đã đăng ký sự kiện " + formData["Event_name"]);
          }

          //InsertNewTicketBookingToFlow();
          InsertNewTicketBooking()
            .then(data => {
              if (debugging === true) {
                console.log('Insert response');
                console.log(data);
              }
            });
        }
        else {
          setVisible2(current => !current);
        }
      }
    }
  }

  const handleClick2 = async (e) => {
    e.preventDefault();
    //lock button
    txt_QRBank_btn = "Đang xử lý";
    setQRBankEnabled(false);

    GenerateBankQRCode()
      .then(QRdata => {
        if (debugging) {
          console.log('QR Response:');
          console.log(QRdata);
        }

        payonQRCode = `data:image/png;base64,${QRdata["data"]["qrcode_image"]}`;
        setQRCode(payonQRCode);

        //toggle visibility
        setVisible2(current => !current);
        setVisible3(current => !current);
      })
      .then(() => InsertNewTicketBooking())
      .then(data => {
        if (debugging) {
          console.log('Insert Response:');
          console.log(data);
        }
      })
      .catch(error => InsertErrorLog(error.message, formData));

  };

  //Nút +/- ticket
  const incrementCount = () => {
    if (NoOfTicket < 10) {
      no_of_ticket++;
      setNoOfTicket(no_of_ticket);
      CalculateDiscount(voucher);
      setFormData({
        name: 'Number_of_Tickets',
        value: no_of_ticket
      })
    }
    if (English === "true") {
      txt_Ve = "Tickets";
    }
  }
  const decrementCount = () => {
    //thêm cho event AI Day
    if (TicketType.includes("ECO")) {
      if (NoOfTicket > 2) {
        no_of_ticket--;
        setNoOfTicket(no_of_ticket);
        CalculateDiscount(voucher);
        setFormData({
          name: 'Number_of_Tickets',
          value: no_of_ticket
        })
      }
    }
    else {
      if (NoOfTicket > 1) {
        no_of_ticket--;
        setNoOfTicket(no_of_ticket);
        CalculateDiscount(voucher);
        setFormData({
          name: 'Number_of_Tickets',
          value: no_of_ticket
        })
      }
      if (English === "true" && NoOfTicket === 2) {
        txt_Ve = "Ticket";
      }
    }
  }

  const onChangeRadio = (event) => {
    //thêm cho event AI Day
    if (event.target.value.includes("ECO")) {
      if (NoOfTicket < 2) {
        no_of_ticket = 2;
        setNoOfTicket(no_of_ticket);
        setFormData({
          name: 'Number_of_Tickets',
          value: no_of_ticket
        })
      }
    }
    setTicketType(event.target.value);
    ticket_price = collection_loai_ve.find(e => e.loai_ve === event.target.value).gia;
    setFormData({
      name: 'Ticket_price',
      value: ticket_price
    })
    setFormData({
      name: 'Ticket_type',
      value: event.target.value
    })
    Ticket_type = event.target.value;
    console.log(event.target.value);
    console.log("1");
    CalculateDiscount(voucher);
  }

  //Handle người giới thiệu
  const handleChangeReferer = (Referer) => {
    let updateReferer = {};

    if (Referer != null) {
      setReferer(Referer);
      let referer = danhsachHoiVien.find(e => e.Hoi_vien_CSMO.Ten_va_cong_ty === Referer.value);
      updateReferer.hoiVienGioiThieuId = referer.Hoi_vien_CSMO.Creator_ID;
    }
    else {
      setReferer("");
      updateReferer.hoiVienGioiThieuId = "";
    }
    console.log(updateReferer.hoiVienGioiThieuId);
    setFormData({
      type: "UPDATE_FIELDS",
      values: updateReferer
    })
  }

  //  
  //Function
  //
  async function Initialize() {
    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/getToken`,
        { method: 'POST' });

      if (!response.ok)
        throw new Error(`Lỗi khi lấy token: ${response}`);

      const data = await response.json();
      return data;
    }
    catch (error) {
      console.log("Lỗi khi lấy token:", error);
      throw error;
    }
  }

  //Get All Vouchers
  async function GetVouchers(_eventId) {
    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/getVouchers?access_token=${accessToken}&eventId=${_eventId}`,
        { method: 'POST' });

      if (!response.ok)
        throw new Error(`Lỗi khi lấy Voucher: ${response}`);

      const data = await response.json();
      return data;
    }
    catch (error) {
      console.log("Lỗi khi lấy Voucher:", error);
      throw error;
    }
  }

  //Lấy record Event từ Creator
  async function GetCurrentEvent(_eventId) {
    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/getEvent?event_Id=${_eventId}&access_token=${accessToken}`,
        { method: 'POST' });

      if (!response.ok)
        throw new Error(`Lỗi khi lấy Event: ${response}`);

      const data = await response.json();
      return data;
    }
    catch (error) {
      console.log("Lỗi khi lấy Event:", error);
      throw error;
    }
  }

  //Tính giá tiền sau khi discount
  function CalculateDiscount(_voucher) {
    // console.log(_voucher["Status"]);
    var Discount_by_ticket = 0;
    var discount_value;
    var hoi_vien_csmo = false;
    if (ticket_price === 0) {
      ticket_price = formData["Ticket_price"];
    }
    var normal_price = ticket_price * no_of_ticket;
    var Final_price = 0;

    //discount theo voucher
    if (voucher !== undefined) {
      var allow = 1;
      if (_voucher["Ma_hoi_vien"] === "true") {
        hoi_vien_csmo = true;
      }
      // if (_voucher["Private"] === "true") {
      //   allow = 0;
      // }
      // if (Private === "true") {
      //   allow = 1;
      // }
      if (_voucher["Status"] === 'Active' && _voucher["Use_time"] > 0 && allow === 1) {
        var Discount_by_voucher = 0;
        if (_voucher["Value_Type"] === 'Percent') {
          Discount_by_voucher = normal_price * _voucher["Effect_Value"] / 100;
        }
        else if (_voucher["Value_Type"] === 'Minus') {
          Discount_by_voucher = _voucher["Effect_Value"];
        }
        Final_price = normal_price - Discount_by_voucher;
        if (_voucher["Value_Type"] === 'Fixed Percent') {
          Discount_by_voucher = normal_price * _voucher["Effect_Value"] / 100;
          Final_price = normal_price - Discount_by_voucher;
        }
      }
      else {
        Final_price = normal_price;
      }
    }
    else {
      Final_price = normal_price;
    }

    //giảm n% cho early bird
    if (creatorEvent["Early_bird"] === "true" && voucher === undefined) {
      discount_value = creatorEvent["Discount_Value"];
      // if (creatorEvent["txt_Price"] === "Early bird" && eventId === "4246561000010098003") {
      //   if (no_of_ticket >= 3) {
      //     discount_value = parseInt(creatorEvent["Discount_Value"]) + 20;
      //   }
      // }
      Final_price = Final_price - normal_price * (discount_value / 100);
    }
    // //discount theo số lượng vé
    if (no_of_ticket >= 5 && eventId === "4246561000010230011" && !hoi_vien_csmo) {
      Discount_by_ticket = Final_price * 10 / 100;
    }
    //vsmcamp
    if (no_of_ticket >= 5 && (eventId === "4246561000010098003" || eventId === "4246561000012392003") && txt_thanh_tien !== "Blind sale" && !hoi_vien_csmo) {
      Discount_by_ticket = Final_price * 10 / 100;
    }
    Final_price = Final_price - Discount_by_ticket;
    if (debugging) {
      console.log(Final_price);
    }

    if (Final_price < 0) {
      Final_price = 0;
    }
    //
    totalInputPrice = Final_price;
    setPrice(totalInputPrice);
    setFormData({
      name: 'Price',
      value: totalInputPrice
    })

  }

  //Tạo một ticket mới
  async function InsertNewTicketBooking() {
    var requestBody = {
      "data": {
        "Payment_Status": 'Waiting',
        "First_name": formData["First_name"],
        "Last_name": formData["Last_name"],
        "Mobile": formData["Mobile"],
        "Gender": formData["Gender"],
        "Ticket_type": Ticket_type,
        "Voucher": formData["Voucher"],
        "Email": formData["Email"],
        "Price": formData["Price"],
        "Ticket_Price": formData["Ticket_price"],
        "Merchant_Request_Id": formData["Merchant_Request_Id"],
        "Number_of_Tickets": no_of_ticket,
        "Event_name": formData["Event_name"],
        "Event_code": formData["Event_code"],
        "Payon_QR_String": payonQRCode,
        "Company": formData["Company"],
        "ZNS_ID": formData["ZNS_ID"],
        "Zeptomail_ID": formData["Zeptomail_ID"],
        "Address": formData["Address"],
        "Tax_code": formData["Tax_code"],
        "LayHoaDon": formData["LayHoaDon"],
        "Position": formData["Position"],
        "hoivien_csmo_lookup": formData["hoiVienId"],
        "hoi_vien_gioi_thieu": formData["hoiVienGioiThieuId"],
        "Dang_ky_CSMO": formData["isHoiVienDangKy"],
        "Hoi_vien_CSMO": formData["isHoiVienChinhThuc"],
        "Error_count": error_count,
        "Error_log": error_log,
      },
      "result": {
        "fields": [
          "ID", "First_name", "Last_name", "Payon_QR_String"
        ],
        "message": true,
        "tasks": true
      }
    };

    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/v2/submitTicket`,
        {
          method: 'POST',
          headers: {
            'Content-Type': "application/json"
          },
          body: JSON.stringify(requestBody)
        });

      const data = await response.json();

      if (data.code !== 3000) {
        InsertErrorLog(data, requestBody);
        console.log(`Lỗi khi tạo Ticket: ${data}`);
      }

      return data;
    }
    catch (error) {
      console.log("Lỗi khi tạo Ticket:", error);
      InsertErrorLog(error, requestBody);
    }
  }

  //Tạo error log
  async function InsertErrorLog(error, body) {
    var requestBody = {
      "data": {
        "Details": error,
        "Status": "New",
        "Request_Body": body
      },
      "result": {
        "fields": [
          "ID"
        ],
        "message": true,
        "tasks": true
      }
    };

    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/v2/submitErrorLog`,
        {
          method: 'POST',
          headers: {
            'Content-Type': "application/json"
          },
          body: JSON.stringify(requestBody)
        });

      const data = await response.json();
      return data;
    }
    catch (error) {
      console.log("Lỗi khi tạo Error Log:", error);
      throw error;
    }
  }

  //Tạo ticket từ Flow
  async function InsertNewTicketBookingToFlow() {
    var requestBody = {
      "data": {
        "Payment_Status": 'Waiting',
        "First_name": formData["First_name"],
        "Last_name": formData["Last_name"],
        "Mobile": formData["Mobile"],
        "Gender": formData["Gender"],
        "Ticket_type": Ticket_type,
        "Voucher": formData["Voucher"],
        "Email": formData["Email"],
        "Price": formData["Price"],
        "Ticket_Price": formData["Ticket_price"],
        "Merchant_Request_Id": formData["Merchant_Request_Id"],
        "Number_of_Tickets": no_of_ticket,
        "Event_name": formData["Event_name"],
        "Event_code": formData["Event_code"],
        "Payon_QR_String": payonQRCode,
        "Company": formData["Company"],
        "ZNS_ID": formData["ZNS_ID"],
        "Zeptomail_ID": formData["Zeptomail_ID"],
        "Address": formData["Address"],
        "Tax_code": formData["Tax_code"],
        "LayHoaDon": formData["LayHoaDon"],
        "Position": formData["Position"],
        "Error_count": error_count,
        "Error_log": error_log,
      }
    };

    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/submitTicketToFlow`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok)
        throw new Error(`Lỗi khi đẩy Flow: ${response.status}`);

      return {};
    }
    catch (error) {
      console.log("Lỗi khi đẩy Flow:", error);
      throw error;
    }
  }

  //Lấy thông tin Hội viên CSMO từ database
  async function getHoiVienCSMO() {
    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/getHoiVienCSMO`, {
        method: 'POST'
      });

      if (!response.ok)
        throw new Error(`Lỗi khi lấy hội viên: ${response.status}`);


      const data = await response.json();
      return data;
    }
    catch (error) {
      console.log("Lỗi khi lấy hội viên:", error);
      throw error;
    }
  }

  //Create Bank QR Code
  async function GenerateBankQRCode() {
    //Basic Auth Encoding
    var baseEncode = Buffer.from(`${PAYONUSERNAME}:${PAYONPASSWORD}`).toString('base64');

    //Payload Info
    var url_notify = "https://ticket-booking-4-1-812297888.catalystserverless.com/server/ticket_booking_4_1_function/webhook";
    var thong_tin_them = formData["Gender"] + " CT " + formData["Company"] + "  " + formData["Position"] + "  " + Ticket_type + " Voucher " + formData["Voucher"];
    if (eventId === "4246561000007894008") {
      thong_tin_them = thong_tin_them + " MST " + formData["Tax_code"];
      url_notify = "https://flow.zoho.com/835058996/flow/webhook/incoming?zapikey=1001.d00fc09adaa3d0026b7df1323f23f201.daafdf792656af903a22e2d002a94051&isdebug=false";
    }
    var requestPayload = {
      "service_type_code": "PAYNOW",
      "service_code": "PAYNOW_QRLOCALBANK_DYNAMIC",
      "method_code": "LOCALBANK",
      "merchant_id": parseInt(MERCHANTID),
      "merchant_request_id": formData["Merchant_Request_Id"].toString(),
      "amount": formData["Price"],
      "bank_code": formData["bank"],
      "description": (formData["Event_name"] + thong_tin_them).replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, ''),
      "currency": "VND",
      "url_redirect": "google.com.vn",
      "url_notify": url_notify,
      "url_cancel": "google.com.vn",
      "customer_fullname": `${formData["First_name"]} ${formData["Last_name"]}`,
      "customer_email": formData["Email"],
      "customer_mobile": formData["Mobile"]
    }

    if (debugging) {
      console.log("Payload");
      console.log(requestPayload);
    }

    //Encrypting Payload
    var encryptedRequestPayload = Encryption(JSON.stringify(requestPayload));

    //MD5 Encrypting
    var md5RequestPayload = MD5(`${APPID}${encryptedRequestPayload}${PAYONKEY}`);

    //Body to send to Payon
    var requestBody = {
      "app_id": APPID,
      "data": encryptedRequestPayload,
      "checksum": md5RequestPayload
    }

    if (debugging) {
      console.log("Body")
      console.log(requestBody);
    }

    try {
      const response = await fetch(`/server/${SERVERDOMAIN}/createBankQRCode?base_encode=${baseEncode}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': "application/json"
          },
          body: JSON.stringify(requestBody)
        });

      const data = await response.json();
      if (data.error_code === '00'){
        throw new Error(`Lỗi khi tạo Bank QR Code: ${JSON.stringify(data)}`);
      }

      return data;
    }
    catch (error) {
      console.log("Lỗi khi tạo Bank QR Code:", error);
      throw new Error(`Lỗi khi tạo Bank QR Code: ${error}`);
    }
  }

  //Encrypt AES 256
  function Encryption(_inputStr) {
    return AES256.encrypt(_inputStr, PAYONKEY);
  }

  return (

    <div className="wrapper">
      <header>
        <MyComponent />
      </header>
      {submitting &&
        <div>
          You are submitting the following:
          <ul>
            {Object.entries(formData).map(([name, value]) => (
              <li key={name}><strong>{name}</strong>:{value.toString()}</li>
            ))}
          </ul>
        </div>
      }
      <div class="img_div">
        {eventId === "4246561000007894008" &&
          <img src={AIDAY_logo} alt="Logo AI Day" className='AIDAY_logo' />
        }
        {eventId === "4246561000014272015" &&
          <img src={Hoa_va_rac_logo} alt="Logo Hoa va Rac" className='Hoa_va_rac_logo' />
        }

      </div>
      {/* form đăng ký */}
      <div id='form-1' className={visible1 ? 'element-visible' : 'element-hidden'}>
        <form onSubmit={handleClick1}>
          {(eventId === "4246561000014272015") &&
            <div class="Guide">
              {(eventId === "4246561000014272015") &&
                <h1 style={{ textAlign: "center" }}>{txt_guide_het_ve}</h1>
              }
              <h5>{txt_guide_0}</h5>
              <p>{txt_guide_1}</p>
              <p>{txt_guide_2}</p>
              <p>{txt_guide_3}</p>
            </div>
          }
          <div class="inputBox">
            <input type="text" name="Mobile" id="Mobile" required onChange={handleChange} />
            <span data-end="*">Mobile</span>
          </div>
          <div class="NameDiv">
            <div className='Firstname_div'>
              <input className='left' type="text" name="First_name" id="First_name" required onChange={handleChange} />
              <span id="spanFirstName" data-end="*">{First_name}</span>
            </div>
            <div className='Lastname_div'>
              <input className='right' type="text" name="Last_name" id="Last_name" required onChange={handleChange} />
              <span id="spanLastName" data-end="*">{Last_name}</span>
            </div>
          </div>

          <div class="inputBox" style={{ marginBottom: "22px" }}>
            <input type="text" name="Email" id="Email" required onChange={handleChange} />
            <span id="spanEmail" data-end="*">Email</span>
          </div>
          {(eventId !== "4246561000014272015") &&
            <div class="inputBox3" style={{ marginBottom: "45px" }}>
              <label for="Company" className="label1" ><span className={dataEnd ? 'span1' : 'span2'} data-end="*">{txt_Company}</span><span style={{ marginLeft: "120px" }}>{txt_Position}</span></label>
              <input id="Company" className='input1' type="text" name="Company" onChange={handleChange} />
              <select id="Position" className='input2 padding7' name="Position" onChange={handleChange}>
                <option value=""></option>
                <option value="Lãnh đạo (C-level)">Lãnh đạo (C-level)</option>
                <option value="Quản lý (Manager)">Quản lý (Manager)</option>
                <option value="Nhân viên (Staff)">Nhân viên (Staff)</option>
                <option value="Khác (Other)">Khác (Other)</option>
              </select>
            </div>}
          {/* <div class="inputBox2" style={{marginBottom: "45px"}}>
                <span>Website công ty</span>
                  <input type="text" name="Company_website" onChange={handleChange}/>
              </div> */}
          {(eventId === "4246561000010098003") &&
            <span className='txt_span'><input style={{ marginBottom: "5px" }} type="checkbox" id="LayHoaDon" name="LayHoaDon" value="Lấy hoá đơn" onChange={handleChange} />
              <label for="LayHoaDon">Anh/Chị có muốn xuất hóa đơn?</label></span>
          }
          <div className={visible1_1 ? 'element-visible' : 'element-hidden'}>
            <div class="inputBox2" style={{ marginBottom: "40px" }}>
              <span data-end="*">Địa chỉ</span>
              <input type="text" name="Address" onChange={handleChange} />
            </div>
            <div class="inputBox2" style={{ marginBottom: "45px" }}>
              <span data-end="*">Mã số thuế</span>
              <input type="text" name="Tax_code" onChange={handleChange} />
            </div>
          </div>
          <div class="gender">
            <label class="label_gender" data-end="*">{Gender}</label>
            <input class="radio_gender" type="radio" id="nam" name="Gender" value="Nam" onChange={handleChange} required />
            <label for="nam">{Male}</label>
            <input class="radio_gender" type="radio" id="nu" name="Gender" value="Nữ" onChange={handleChange} />
            <label for="nu">{Female}</label>
          </div>
          <div className={`chay ${visibleOption1 ? 'element-visible' : 'element-hidden'}`}>
            <label class="label_chay">Anh/Chị có ăn chay không?</label>
            <input type="radio" id="Co" name="Chay_radio" value="Có" onChange={handleChange} />
            <label class="label_radio_chay" for="Co">Có</label>
            <input type="radio" id="Khong" name="Chay_radio" value="Không" onChange={handleChange} />
            <label class="label_radio_chay" for="Khong">Không</label>
          </div>
          <div className={`gender ${visibleOption2 ? 'element-visible' : 'element-hidden'}`}>
            <label class="label_chay">Anh/Chị là Hội Viên CSMO?</label>
            <input type="radio" id="Co2" name="Hoivien_radio" value="Có" onChange={handleChange} />
            <label class="label_radio_chay" for="Co2">Có</label>
            <input type="radio" id="Khong2" name="Hoivien_radio" value="Không" onChange={handleChange} />
            <label class="label_radio_chay" for="Khong2">Không</label>
          </div>
          <div className={`row ${enabled ? 'enabled' : 'disabled'}`}>
            <div className={`column1 ${enabled_column1 ? 'enabled' : 'disabled'}`}>
              {/* <span className='txt_span'>{txt_loai_ve}</span> */}
              {English !== "true" &&
                <div class="radio_loaive">
                  {collection_loai_ve.map((option) => (
                    <span>
                      <input type="radio" name="Ticket_type" checked={TicketType === option.loai_ve} value={option.loai_ve} id={option.option_id} onChange={onChangeRadio} /> {option.loai_ve}
                      <br></br>
                    </span>
                  ))}
                </div>
              }

              {eventId === "4246561000014272015" && English === "true" &&
                <div class="radio_loaive" style={{ marginTop: "10px" }}>
                  {collection_loai_ve.map((option) => (
                    <span>
                      <input type="radio" name="Ticket_type" checked={TicketType === option.loai_ve} value={option.loai_ve} id={option.option_id} onChange={onChangeRadio} /> {option.eng_loai_ve}
                      <br></br>
                    </span>
                  ))}
                </div>
              }

              {/* {eventId == "4246561000014272015" && English == "true" &&
                <div class="radio_loaive">
                  <span>
                  <form>
                  <input type="radio" id="radiovalue1" name="Ticket_type" value='19h30 - Ngày 12/04/2025' onChange={onChangeRadio} disable='false' />
                  <label for="radiovalue1">19h30 - April 12, 2025</label><br></br>
                  <input type="radio" id="radiovalue2" name="Ticket_type" value='19h30 - Ngày 13/04/2025' onChange={onChangeRadio}/>
                  <label for="radiovalue2">19h30 - April 13, 2025</label><br></br>
                  </form> 
                  </span>
                   </div>
              } */}
              {(eventId !== "4246561000015270003") &&
                <div class="Voucher">
                  <span>Voucher</span>
                  <input type="text" name="Voucher" onChange={voucherChange2} />
                </div>}
            </div>
            <div className='column2'>
              <div class="ticket-group">
                <input className='element-hidden' type="number" name="Number_of_Tickets" value={NoOfTicket} required min="1" />
                <button id="increBtn" type='button' className='vertical-btn' onClick={incrementCount}>˄</button>
                <div><span className='ticket'>{NoOfTicket}</span><span className='Ve'>{txt_Ve}</span></div>
                <button id="decreBtn" type='button' className='vertical-btn' onClick={decrementCount}>˅</button>
              </div>
            </div>
          </div>
          {(eventId === "4246561000010098003" || eventId === "4246561000012392003") &&
            <div style={{ marginBottom: "40px" }}></div>}

          {eventId === "4246561000007894008" &&
            <div style={{ marginBottom: "20px" }}> </div>}
          {event_csmo === "true" &&
            <div class="Referer" >
              <label for="Referer"  ><span className="label1">Người giới thiệu (không bắt buộc)</span></label>
              <Select
                id="Referer"
                value={Referer}
                onChange={handleChangeReferer}
                options={Referer_options}
                isClearable
              />
            </div>
          }

          {(eventId !== "4246561000015270003") &&
            <div class="inputBox2" style={{ marginBottom: "40px" }}>
              <span>{txt_thanh_tien}</span>
              <CurrencyInput suffix=" đ" disabled className='Currency' name="Price" value={totalPrice} onChange={handleChange} />
            </div>}
          <div class="btn_group">
            {(eventId !== "4246561000014272015") &&
              <input hidden={btn1Visible} disabled={btn1disable} class="btn-grad" type="submit" value={txt_Dang_ky} />
            }
            {(eventId === "4246561000014272015") &&
              <input hidden={btn1Visible} disabled={btn1disable} class="btn-grad2" type="submit" value={txt_Dang_ky} />
            }
          </div>
        </form>
      </div>
      {/* form chọn ngân hàng */}
      <div className={`formBank ${visible2 ? 'element-visible' : 'element-hidden'} ${QRBankenabled ? 'enabled' : 'disabled'}`}>
        <form onSubmit={handleClick2}>
          <p>Số tiền phải thanh toán là {totalPrice} VNĐ</p>
          <p>Vui lòng chọn ngân hàng bạn sẽ sử dụng để thanh toán QR payment, sau đó bấm nút "Lấy QR code"</p>
          <label for="bank">Ngân hàng  </label>
          <img src={bank_url} alt="Icon" width="35px" height="35px" />
          <select className='select_bank' name="bank" id="bank" onChange={handleChange} required>
            <option value=""></option>
            <option value="ABB">ABB - NH TMCP An Bình</option>
            <option value="ACB">ACB - NH TMCP Á Châu</option>
            <option value="AGB">AGB - NH Nông nghiệp và Phát triển Nông thôn Agribank</option>
            <option value="BAB">BAB - NH TMCP Bắc Á</option>
            <option value="BIDV">BIDV - NH Đầu tư và Phát triển Việt Nam</option>
            <option value="BVB">BVB - NH TMCP Bảo Việt</option>
            <option value="EXB">EXB - NH TMCP Xuất Nhập Khẩu</option>
            <option value="HDB">HDB - NH TMCP Phát Triển TPHCM</option>
            <option value="ICB">ICB - NH TMCP Công Thương Vietinbank</option>
            <option value="MB">MB - NH TMCP Quân Đội</option>
            <option value="MSB">MSB - NH TMCP Hàng Hải</option>
            <option value="NAB">NAB - NH TMCP Nam Á</option>
            <option value="NCB">NCB - NH TMCP Quốc Dân</option>
            <option value="OCB">OCB - NH TMCP Phương Đông Việt Nam</option>
            <option value="OJB">OJB - NH Thương mại TNHH MTV Đại Dương</option>
            <option value="PVB">PVB - NH TMCP Đại Chúng Việt Nam</option>
            <option value="SCB">SCB - NH TMCP Sài Gòn</option>
            <option value="SEA">SEA - NH TMCP Đông Nam Á</option>
            <option value="SGB">SGB - NH TMCP Sài Gòn Công Thương</option>
            <option value="SHB">SHB - NH TMCP Sài Gòn - Hà Nội</option>
            <option value="SHBKV">SHBKV - NH TNHH MTV Shinhan Việt Nam</option>
            <option value="TCB">TCB - NH TMCP Kỹ Thương Techcombank</option>
            <option value="TPB">TPB - NH TMCP Tiên Phong</option>
            <option value="VB">VB - NH TMCP Việt Nam Thương Tín</option>
            <option value="VPB">VPB - NH TMCP Việt Nam Thịnh Vượng</option>
            <option value="STB">STB - NH TMCP Sài Gòn Thương Tín, Sacombank</option>
            <option value="VCB">VCB - NH TMCP Ngoại Thương Việt Nam, Vietcombank</option>
          </select>
          <div className={`btn_group ${visible2_1 ? 'element-visible' : 'element-hidden'}`}>
            <input type='submit' class="btn-grad" value={txt_QRBank_btn} />
          </div>
        </form>
      </div>

      {/* form QR code */}
      <div className={`formQR ${visible3 ? 'element-visible' : 'element-hidden'}`}>
        <p>{underQRText}</p>
        <img alt="qr" width="300" height="300" src={qrCode} />
        <div className='txt_group'>
          <img src={img_quet_qr} alt="huong_dan_quet_qr" />
          <h5>{txt_form_QR4}</h5>
          <h5>{txt_form_QR5}</h5>
        </div>
        {/* <button class='btn-back' onClick={Redirect}>Trở về trang đăng ký</button> */}
      </div>

      {/* form thông báo thành công */}
      <div className={`formThongBao ${visible4 ? 'element-visible' : 'element-hidden'}`}>
        <img alt="ok_icon" src='https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Eo_circle_green_white_checkmark.svg/2048px-Eo_circle_green_white_checkmark.svg.png' width="80px" height="80px"></img>
        <h2 class='green'>{txt_form_thongbao_0}</h2>
        <h3>{txt_form_thongbao_1}</h3>
        <h4>{txt_form_thongbao_2}</h4>
        {/* <button class='btn-back' onClick={Redirect}>Trở về trang đăng ký</button> */}
      </div>

    </div>
  );
}

export default App;